// SEQ-240 audit B, row 30. A member (not an organisation admin) only sees the
// projects they belong to or created, and the P&L page's "All projects" totals
// cover only those. Two members saw 0 and 1 project of 31 with no message, so
// the page now says how many they can see.

/** The sentence shown to a member, or null when there is nothing to say yet. */
export function memberProjectScopeNote(visibleProjectCount: number): string | null {
  if (!Number.isFinite(visibleProjectCount) || visibleProjectCount < 0) return null;
  const count = Math.floor(visibleProjectCount);
  if (count === 0) {
    return "You can see 0 projects, so every total on this page is empty. Ask an admin to add you to the projects you need.";
  }
  const noun = count === 1 ? "project" : "projects";
  return `You can see ${count} ${noun}, so every total on this page covers only ${count === 1 ? "that project" : "those projects"}, not the whole company.`;
}
